import { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { API } from "@/App";
import { toast } from "sonner";

export const useAccountKnowledge = (accountId, onChanged) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [enriching, setEnriching] = useState(false);
  const [saving, setSaving] = useState(false);

  const load = useCallback(async (notify = false) => {
    if (!accountId) return;
    try {
      const { data: d } = await axios.get(`${API}/knowledge/account/${accountId}`);
      setData(d);
      if (notify) onChanged?.({ relationship: d.relationship, status: d.status, website: d.website, industry: d.industry, knowledge: d.knowledge });
    } catch (e) {
      console.error("knowledge load failed", e);
    } finally { setLoading(false); }
  }, [accountId, onChanged]);

  useEffect(() => { load(); }, [load]);

  const enrich = async () => {
    setEnriching(true);
    try {
      await axios.post(`${API}/knowledge/account/${accountId}/enrich`, null, { timeout: 90000 });
      await load(true);
      toast.success("Account knowledge refreshed");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Could not enrich this account");
    } finally { setEnriching(false); }
  };

  const save = async (patch) => {
    setSaving(true);
    try {
      await axios.put(`${API}/knowledge/account/${accountId}`, patch);
      await load(true);
      toast.success("Saved");
      return true;
    } catch (e) {
      toast.error(e.response?.data?.detail || "Could not save");
      return false;
    } finally { setSaving(false); }
  };

  return { data, loading, enriching, saving, enrich, save, reload: load };
};
